import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	rows?: number;
};

export const DetailCardSkeleton: FC<Props> = ({ rows = 4 }) => {
	const theme = useTheme();

	return (
		<Stack>
			<Stack px={theme.spacingTokens.lg} pt={2.4} pb={theme.spacingTokens.sm}>
				<Skeleton variant="text" width={120} height={14} animation="wave" />
			</Stack>
			<Stack bgcolor={theme.palette.background.paper}>
				{Array.from({ length: rows }).map((_, index) => (
					<Stack
						// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
						key={index}
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						px={theme.spacingTokens.lg}
						py={theme.spacingTokens.md}
						sx={{
							borderBottom: theme.colors.border.solid(theme.palette.divider),
							"&:last-of-type": { borderBottom: "none" },
						}}
					>
						<Skeleton variant="text" width="30%" height={16} animation="wave" />
						<Skeleton variant="text" width="25%" height={16} animation="wave" />
					</Stack>
				))}
			</Stack>
		</Stack>
	);
};
